var map = {
	"./HeadersDialog.vue": 4304,
	"./Links.vue": 5573,
	"./MaterialAlert.vue": 6787,
	"./MaterialCard.vue": 3924,
	"./MaterialChartCard.vue": 3983,
	"./MaterialSnackbar.vue": 7322,
	"./MaterialStatsCard.vue": 7741,
	"./NewOrdersTable.vue": 349,
	"./OrderHeadersDialog.vue": 2779,
	"./ViewAllOrders.vue": 1215,
	"./ViewNewOrders.vue": 3819,
	"./ViewOrganisations.vue": 2256,
	"./ViewUsers.vue": 4174,
	"./app/BarItem.vue": 630,
	"./app/Btn.vue": 9596,
	"./app/Card.vue": 8683,
	"./app/Tabs.vue": 2765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3808;